<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 7/9/2020
  -->

<template>
	<div class="radio-element-root" v-bind="attrsStylesClass">
		<FormMultipleView
			:formElement="formElement"
			:viewMode="viewMode"
			v-bind="$attrs">
			<template #elementEditMode>
				<div class="disableClick" @click.prevent>
					<el-radio v-model="radioModel" class="editMode"/>
				</div>
			</template>
			<template #viewList="{formElement}">
				<FormRow :showDivider="false">
					<el-radio-group v-model="formElement.selectedIndex" class="w-100"
					@change="onRadioChanged(formElement)">
						<div v-for="(option, index) in formElement.answerOptions" :key="index" class="item-height row mx-0 align-items-center"
						:class="{disableClick: isViewMode, 'answer': isAnswerMode}"
						@click="onRadioClicked">
							<el-radio :label="index" :class="{'input-disabled': isViewMode}">{{ option }}</el-radio>
						</div>

						<div v-if="formElement.showOtherOption" class="item-height row mx-0 align-items-center"
							 :class="{disableClick: isViewMode, 'answer': isAnswerMode}"
							 @click="onRadioClicked">
							<el-radio :label="otherIndex" :class="{'input-disabled': isViewMode}">Other:</el-radio>
							<div class="col px-0">
								<qw-input v-model="formElement.otherAnswer"
										  :readonly="!isAnswerMode"
										  :placeholder="isAnswerMode ? 'type here' : ''"
										  @input="onOtherTextChanged(formElement)"></qw-input>
							</div>
						</div>
					</el-radio-group>
				</FormRow>
			</template>

			<template #menuOptionsLeft>
				<div>
<!--					12-->
				</div>

			</template>
		</FormMultipleView>
	</div>


</template>

<script>
import FormMultipleView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementMultipleView.vue";
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import BaseFormElementView from "@/core/modules/coach/Resources/Forms/FormElements/BaseFormElementView.vue";
import QwInput from "@/core/components/Controls/QwInput.vue";
import FormElementRadioButtons from "@/core/modules/coach/Resources/Forms/model/FormElements/General/FormElementRadioButtons";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

export default {
	name: "FormElementRadioView",
	components: {ToolTipView, QwInput, FormRow, FormMultipleView},
	extends: BaseFormElementView,
	props:{
		formElement: FormElementRadioButtons
	},
	inheritAttrs: false,

	data() {
		return {
			radioModel: false,
		}
	},

	methods:{
		onOtherTextChanged(formElement){
			if(this.formElement.selectedIndex !== this.otherIndex){
				this.formElement.selectedIndex = this.otherIndex
			}
			formElement.answer = formElement.otherAnswer
		},

		onRadioChanged(formElement){
			let index = formElement.selectedIndex
			console.log("onRadioChanged: index = ", index)
			if(index === this.otherIndex){
				formElement.answer = formElement.otherAnswer
			} else if(index >= 0){
				formElement.answer = formElement.answerOptions[index]
			}
			console.log("onRadioChanged: formElement.answer = ", formElement.answer)
			this.$emit("change", formElement)
		},

		onRadioClicked(event){
			if(this.isViewMode){
				event.preventDefault()
			}
		}
	},

	computed:{
		otherIndex(){
			return this.formElement.answerOptions.length
		}
	}


}
</script>

<style lang="scss">

.radio-element-root {
	.disableClick {
		cursor: default;
		outline: none;

		.el-radio__inner {
			border: 1px solid #DCDFE6;
			box-shadow: none !important;
			cursor: default;
			//background: none !important;
			&::afters{
				//background: none !important;
			}
		}
		.editMode{
			.el-radio__label{
				padding-left: 0;
			}
		}
		.el-radio, .el-radio__input, .el-radio__label, .el-radio__inner {
			cursor: default;
		}
	}
}

</style>
